import Vue from "vue";
import App from "./App.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faExternalLinkAlt);
library.add(faPlay);

Vue.prototype.$log = console.log;
Vue.component("fa-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

// Require the main Sass manifest file
require("./assets/main.scss");

new Vue({
  render: h => h(App)
}).$mount("#app");
